export default {"src":"/_next/static/media/logo-13.ee515832.svg","height":51,"width":48,"blurWidth":0,"blurHeight":0};